
export class FormData {
  packageId = undefined;
  planId = undefined;
  cardNumber = '';
  ccvCode = '';
  expiryDate = '';
  nameOnCard = '';
  paymentToken = '';
  registerToken = '';
  clear() {
      this.packageId = undefined;
      this.planId = undefined;
      this.cardNumber = '';
      this.ccvCode = '';
      this.expiryDate = '';
      this.nameOnCard = '';
      this.registerToken = '';
      this.paymentToken = '';
  }

}

export class Payment {
  cardNumber = '';
  ccvCode = '';
  expiryDate = '';
  nameOnCard = '';
  registerToken = '';
  paymentToken = '';
}
